import * as React from 'react';
import { __ } from 'react-i18n';
import { withRouter } from 'react-router';
import { Modal } from '../../Defaults/Modal/Modal';
import { IconType, DsiSvgIcon as SvgIcon } from '../General/SvgIcon';
import styled from 'styled-components';
import { Button } from '../General/Button';

interface Props {
  location?: any;
}

const RegistrationModal = ({ location }: Props) => {
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    if (location?.query?.r == 1) {
      setIsOpen(true);
      if (window?.location?.href) {
        const url = new URL(window.location.href);
        url.searchParams.set('r', '0');
        window.history.pushState({}, '', url.toString());
      }
    }
  }, []);

  const closeModal = () => {
    setIsOpen(false);
  };

  return isOpen ? (
    <Modal
      style={{ height: 'initial' }}
      size="medium"
      showX={false}
      closeModal={closeModal}
    >
      <ContentWrapper>
        <SvgWrapper>
          <SvgIcon
            width={256}
            height={256}
            icon={IconType.finishedOrder}
            alt="Success Icon"
            viewBox="0 0 48 48"
            fill="#36BF91"
          />
        </SvgWrapper>
        <RegTitle>{__('Ďakujeme za registráciu!')}</RegTitle>
        <RegText>
          {__('Vaša registrácia bola úspešne dokončená.')}
          <br />
          {__('Teraz môžete pokračovať v nakupovaní ako prihlásený zákazník.')}
        </RegText>
        <ContinueButton onClick={closeModal}>{__('Pokračovať')}</ContinueButton>
      </ContentWrapper>
    </Modal>
  ) : (
    <></>
  );
};

// Styled Components
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 20px;

  border-radius: 10px;
`;

const SvgWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 24px; /* Adds more spacing between the icon and the text */
`;

const RegTitle = styled.h2`
  font-size: 24px;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0;
  margin-bottom: 16px;
  text-align: center;
`;

const RegText = styled.p`
  text-align: center;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0;
  margin-bottom: 24px; /* Adds spacing before the button */
  line-height: 1.5; /* Improves readability */
`;

const ContinueButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
  border: none;
`;

const RegistrationModalWithRouter = withRouter(RegistrationModal);
export { RegistrationModalWithRouter as DsiRegistrationModal };
